import script from "./PublicFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicFooter.vue?vue&type=script&setup=true&lang=ts"

import "./PublicFooter.vue?vue&type=style&index=0&id=fa7ba0cc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.4.38_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa7ba0cc"]])

export default __exports__